export var lightTheme = {
    themeName: "light",
    background: "rgba(252,253,254,1)",
    black: "rgba(33, 33, 33, 1)",
    blue: "rgba(17, 147, 240, 1)",
    blueDark: "rgba(11, 103, 170, 1)",
    blueLight: "rgba(89, 180, 245, 1)",
    concrete: "rgba(153, 153, 153, 1)",
    danger: "rgba(245, 0, 50, 1)",
    dangerDark: "rgba(219, 0, 45, 1)",
    gold: "rgba(224, 157, 26, 1)",
    goldLight: "rgba(255, 247, 206, 1)",
    green: "rgba(63, 220, 127, 1)",
    greenDark: "rgba(21, 128, 61, 1)",
    greenLight: "rgba(210, 255, 174, 1)",
    lake: "rgba(225, 251, 255, 1)",
    lakeDark: "rgba(208, 229, 234, 1)",
    lakeLight: "rgba(241, 253, 255, 1)",
    meteor: "rgba(0, 120, 137, 1)",
    meteorDark: "rgba(9, 47, 50, 1)",
    meteorLight: "rgba(5, 146, 166, 1)",
    navy: "rgba(20, 69, 164, 1)",
    navyDark: "rgba(14, 54, 133, 1)",
    navyLight: "rgba(72, 130, 245, 1)",
    pink: "rgba(255, 67, 105, 1)",
    pinkDark: "rgba(225, 29, 72, 1)",
    pinkLight: "rgba(255, 143, 166, 1)",
    purple: "rgba(139, 127, 255, 1)",
    purpleDark: "rgba(109, 40, 217, 1)",
    purpleLight: "rgba(196, 181, 253, 1)",
    red: "rgba(255, 0, 0, 1)",
    redDark: "rgba(174, 33, 33, 1)",
    redLight: "rgba(255, 57, 57, 1)",
    slate: "rgba(211, 220, 230, 1)",
    slateDark: "rgba(192, 204, 217, 1)",
    slateLight: "rgba(224, 236, 249, 1)",
    smoke: "rgba(204, 204, 204, 1)",
    smokeDark: "rgba(187, 187, 187, 1)",
    smokeLight: "rgba(241, 241, 241, 1)",
    snow: "rgba(239, 242, 247, 1)",
    snowDark: "rgba(229, 233, 242, 1)",
    snowLight: "rgba(249, 250, 252, 1)",
    steel: "rgba(87, 87, 87, 1)",
    success: "rgba(32, 175, 90, 1)",
    turquoise: "rgba(65, 211, 231, 1)",
    turquoiseDark: "rgba(25, 174, 195, 1)",
    turquoiseLight: "rgba(133, 227, 240, 1)",
    warning: "rgba(251, 181, 43, 1)",
    warningLight: "rgba(255, 199, 89, 1)",
    whale: "rgba(61, 93, 116, 1)",
    whaleDark: "rgba(48, 74, 98, 1)",
    whaleLight: "rgba(126, 140, 148, 1)",
    white: "rgba(252, 253, 254, 1)",
    // Status Badge Colors
    emerald500: "rgba(16, 185, 129, 1)",
    emerald500_10: "rgba(16, 185, 129, 0.1)",
    emerald500_15: "rgba(16, 185, 129, 0.15)",
    emerald500_30: "rgba(16, 185, 129, 0.3)",
    emerald500_40: "rgba(16, 185, 129, 0.4)",
    emerald500_50: "rgba(16, 185, 129, 0.5)",
    emerald500_80: "rgba(16, 185, 129, 0.8)",
    blue500: "rgba(59, 130, 246, 1)",
    blue500_10: "rgba(59, 130, 246, 0.1)",
    blue500_15: "rgba(59, 130, 246, 0.15)",
    blue500_30: "rgba(59, 130, 246, 0.3)",
    blue500_50: "rgba(59, 130, 246, 0.5)",
    blue500_80: "rgba(59, 130, 246, 0.8)",
    red500: "rgba(239, 68, 68, 1)",
    red500_10: "rgba(239, 68, 68, 0.1)",
    red500_15: "rgba(239, 68, 68, 0.15)",
    red500_30: "rgba(239, 68, 68, 0.3)",
    red500_50: "rgba(239, 68, 68, 0.5)",
    red500_80: "rgba(239, 68, 68, 0.8)",
    slate500: "rgba(100, 116, 139, 1)",
    slate500_10: "rgba(100, 116, 139, 0.1)",
    slate500_15: "rgba(100, 116, 139, 0.15)",
    slate500_30: "rgba(100, 116, 139, 0.3)",
    slate500_50: "rgba(100, 116, 139, 0.5)",
    slate500_80: "rgba(100, 116, 139, 0.8)",
    amber500: "rgba(245, 158, 11, 1)",
    amber500_10: "rgba(245, 158, 11, 0.1)",
    amber500_15: "rgba(245, 158, 11, 0.15)",
    amber500_30: "rgba(245, 158, 11, 0.3)",
    amber500_50: "rgba(245, 158, 11, 0.5)",
    amber500_80: "rgba(245, 158, 11, 0.8)",
};
export var darkTheme = {
    themeName: "dark",
    background: "rgba(26,26,26,1)",
    black: "rgba(247,248,248,1)",
    blue: "rgba(17, 147, 240, 1)",
    blueDark: "rgba(36,145,222,1)",
    blueLight: "rgba(169,211,242,1)",
    concrete: "rgba(133, 133, 133, 1)",
    danger: "rgba(245, 0, 50, 1)",
    dangerDark: "rgba(219, 0, 45, 1)",
    gold: "rgba(224, 157, 26, 1)",
    goldLight: "rgba(255, 247, 206, 1)",
    green: "rgba(63, 220, 127, 1)",
    greenDark: "rgba(25, 140, 73, 1)",
    greenLight: "rgba(210, 255, 174, 1)",
    lake: "rgba(225, 251, 255, 1)",
    lakeDark: "rgba(208, 229, 234, 1)",
    lakeLight: "rgba(44, 45, 52, 1)",
    meteor: "rgba(0, 120, 137, 1)",
    meteorDark: "rgba(0, 120, 137, 1)",
    meteorLight: "rgba(5, 146, 166, 1)",
    navy: "rgba(20, 69, 164, 1)",
    navyDark: "rgba(14, 54, 133, 1)",
    navyLight: "rgba(72, 130, 245, 1)",
    pink: "rgba(255, 67, 105, 1)",
    pinkDark: "rgba(242,80,114,1)",
    pinkLight: "rgba(252,222,228,1)",
    purple: "rgba(139, 127, 255, 1)",
    purpleDark: "rgba(109, 40, 217, 1)",
    purpleLight: "rgba(196, 181, 253, 1)",
    red: "rgba(255, 0, 0, 1)",
    redDark: "rgba(174, 33, 33, 1)",
    redLight: "rgba(255, 57, 57, 1)",
    slate: "rgba(83, 87, 92, 1)",
    slateDark: "rgba(192, 204, 217, 1)",
    slateLight: "rgba(224, 236, 249, 1)",
    smoke: "rgba(59,62,65,1)",
    smokeDark: "rgba(187, 187, 187, 1)",
    smokeLight: "rgba(241, 241, 241, 1)",
    snow: "rgba(58, 58, 58, 1)",
    snowDark: "rgba(84, 84, 84, 1)",
    snowLight: "rgba(33, 33, 33, 1)",
    steel: "rgba(153, 153, 153, 1)",
    success: "rgba(32, 175, 90, 1)",
    turquoise: "rgba(65, 211, 231, 1)",
    turquoiseDark: "rgba(25, 174, 195, 1)",
    turquoiseLight: "rgba(206,239,244,1)",
    warning: "rgba(251, 181, 43, 1)",
    warningLight: "rgba(255, 199, 89, 1)",
    whale: "rgba(61, 93, 116, 1)",
    whaleDark: "rgba(137, 156, 166, 1)",
    whaleLight: "rgba(126, 140, 148, 1)",
    white: "rgba(26, 26, 26, 1)",
    // Status Badge Colors (Dark Theme)
    emerald500: "rgba(16, 185, 129, 1)",
    emerald500_10: "rgba(16, 185, 129, 0.1)",
    emerald500_15: "rgba(16, 185, 129, 0.15)",
    emerald500_30: "rgba(16, 185, 129, 0.3)",
    emerald500_40: "rgba(16, 185, 129, 0.4)",
    emerald500_50: "rgba(16, 185, 129, 0.5)",
    emerald500_80: "rgba(16, 185, 129, 0.8)",
    blue500: "rgba(59, 130, 246, 1)",
    blue500_10: "rgba(59, 130, 246, 0.1)",
    blue500_15: "rgba(59, 130, 246, 0.15)",
    blue500_30: "rgba(59, 130, 246, 0.3)",
    blue500_50: "rgba(59, 130, 246, 0.5)",
    blue500_80: "rgba(59, 130, 246, 0.8)",
    red500: "rgba(239, 68, 68, 1)",
    red500_10: "rgba(239, 68, 68, 0.1)",
    red500_15: "rgba(239, 68, 68, 0.15)",
    red500_30: "rgba(239, 68, 68, 0.3)",
    red500_50: "rgba(239, 68, 68, 0.5)",
    red500_80: "rgba(239, 68, 68, 0.8)",
    slate500: "rgba(100, 116, 139, 1)",
    slate500_10: "rgba(100, 116, 139, 0.1)",
    slate500_15: "rgba(100, 116, 139, 0.15)",
    slate500_30: "rgba(100, 116, 139, 0.3)",
    slate500_50: "rgba(100, 116, 139, 0.5)",
    slate500_80: "rgba(100, 116, 139, 0.8)",
    amber500: "rgba(245, 158, 11, 1)",
    amber500_10: "rgba(245, 158, 11, 0.1)",
    amber500_15: "rgba(245, 158, 11, 0.15)",
    amber500_30: "rgba(245, 158, 11, 0.3)",
    amber500_50: "rgba(245, 158, 11, 0.5)",
    amber500_80: "rgba(245, 158, 11, 0.8)",
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGhlbWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0aGVtZS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsTUFBTSxDQUFDLElBQU0sVUFBVSxHQUFpQjtJQUN0QyxTQUFTLEVBQUUsT0FBTztJQUNsQixVQUFVLEVBQUUscUJBQXFCO0lBQ2pDLEtBQUssRUFBRSxxQkFBcUI7SUFDNUIsSUFBSSxFQUFFLHVCQUF1QjtJQUM3QixRQUFRLEVBQUUsdUJBQXVCO0lBQ2pDLFNBQVMsRUFBRSx1QkFBdUI7SUFDbEMsUUFBUSxFQUFFLHdCQUF3QjtJQUNsQyxNQUFNLEVBQUUscUJBQXFCO0lBQzdCLFVBQVUsRUFBRSxxQkFBcUI7SUFDakMsSUFBSSxFQUFFLHVCQUF1QjtJQUM3QixTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLEtBQUssRUFBRSx1QkFBdUI7SUFDOUIsU0FBUyxFQUFFLHNCQUFzQjtJQUNqQyxVQUFVLEVBQUUsd0JBQXdCO0lBQ3BDLElBQUksRUFBRSx3QkFBd0I7SUFDOUIsUUFBUSxFQUFFLHdCQUF3QjtJQUNsQyxTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLE1BQU0sRUFBRSxzQkFBc0I7SUFDOUIsVUFBVSxFQUFFLG9CQUFvQjtJQUNoQyxXQUFXLEVBQUUsc0JBQXNCO0lBQ25DLElBQUksRUFBRSxzQkFBc0I7SUFDNUIsUUFBUSxFQUFFLHNCQUFzQjtJQUNoQyxTQUFTLEVBQUUsdUJBQXVCO0lBQ2xDLElBQUksRUFBRSx1QkFBdUI7SUFDN0IsUUFBUSxFQUFFLHNCQUFzQjtJQUNoQyxTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLE1BQU0sRUFBRSx3QkFBd0I7SUFDaEMsVUFBVSxFQUFFLHVCQUF1QjtJQUNuQyxXQUFXLEVBQUUsd0JBQXdCO0lBQ3JDLEdBQUcsRUFBRSxvQkFBb0I7SUFDekIsT0FBTyxFQUFFLHNCQUFzQjtJQUMvQixRQUFRLEVBQUUsc0JBQXNCO0lBQ2hDLEtBQUssRUFBRSx3QkFBd0I7SUFDL0IsU0FBUyxFQUFFLHdCQUF3QjtJQUNuQyxVQUFVLEVBQUUsd0JBQXdCO0lBQ3BDLEtBQUssRUFBRSx3QkFBd0I7SUFDL0IsU0FBUyxFQUFFLHdCQUF3QjtJQUNuQyxVQUFVLEVBQUUsd0JBQXdCO0lBQ3BDLElBQUksRUFBRSx3QkFBd0I7SUFDOUIsUUFBUSxFQUFFLHdCQUF3QjtJQUNsQyxTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLEtBQUssRUFBRSxxQkFBcUI7SUFDNUIsT0FBTyxFQUFFLHNCQUFzQjtJQUMvQixTQUFTLEVBQUUsdUJBQXVCO0lBQ2xDLGFBQWEsRUFBRSx1QkFBdUI7SUFDdEMsY0FBYyxFQUFFLHdCQUF3QjtJQUN4QyxPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLFlBQVksRUFBRSx1QkFBdUI7SUFDckMsS0FBSyxFQUFFLHNCQUFzQjtJQUM3QixTQUFTLEVBQUUscUJBQXFCO0lBQ2hDLFVBQVUsRUFBRSx3QkFBd0I7SUFDcEMsS0FBSyxFQUFFLHdCQUF3QjtJQUUvQixzQkFBc0I7SUFDdEIsVUFBVSxFQUFFLHVCQUF1QjtJQUNuQyxhQUFhLEVBQUUseUJBQXlCO0lBQ3hDLGFBQWEsRUFBRSwwQkFBMEI7SUFDekMsYUFBYSxFQUFFLHlCQUF5QjtJQUN4QyxhQUFhLEVBQUUseUJBQXlCO0lBQ3hDLGFBQWEsRUFBRSx5QkFBeUI7SUFDeEMsYUFBYSxFQUFFLHlCQUF5QjtJQUV4QyxPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLFVBQVUsRUFBRSx5QkFBeUI7SUFDckMsVUFBVSxFQUFFLDBCQUEwQjtJQUN0QyxVQUFVLEVBQUUseUJBQXlCO0lBQ3JDLFVBQVUsRUFBRSx5QkFBeUI7SUFDckMsVUFBVSxFQUFFLHlCQUF5QjtJQUVyQyxNQUFNLEVBQUUsc0JBQXNCO0lBQzlCLFNBQVMsRUFBRSx3QkFBd0I7SUFDbkMsU0FBUyxFQUFFLHlCQUF5QjtJQUNwQyxTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLFNBQVMsRUFBRSx3QkFBd0I7SUFDbkMsU0FBUyxFQUFFLHdCQUF3QjtJQUVuQyxRQUFRLEVBQUUsd0JBQXdCO0lBQ2xDLFdBQVcsRUFBRSwwQkFBMEI7SUFDdkMsV0FBVyxFQUFFLDJCQUEyQjtJQUN4QyxXQUFXLEVBQUUsMEJBQTBCO0lBQ3ZDLFdBQVcsRUFBRSwwQkFBMEI7SUFDdkMsV0FBVyxFQUFFLDBCQUEwQjtJQUV2QyxRQUFRLEVBQUUsdUJBQXVCO0lBQ2pDLFdBQVcsRUFBRSx5QkFBeUI7SUFDdEMsV0FBVyxFQUFFLDBCQUEwQjtJQUN2QyxXQUFXLEVBQUUseUJBQXlCO0lBQ3RDLFdBQVcsRUFBRSx5QkFBeUI7SUFDdEMsV0FBVyxFQUFFLHlCQUF5QjtDQUN2QyxDQUFDO0FBRUYsTUFBTSxDQUFDLElBQU0sU0FBUyxHQUFpQjtJQUNyQyxTQUFTLEVBQUUsTUFBTTtJQUNqQixVQUFVLEVBQUUsa0JBQWtCO0lBQzlCLEtBQUssRUFBRSxxQkFBcUI7SUFDNUIsSUFBSSxFQUFFLHVCQUF1QjtJQUM3QixRQUFRLEVBQUUsb0JBQW9CO0lBQzlCLFNBQVMsRUFBRSxxQkFBcUI7SUFDaEMsUUFBUSxFQUFFLHdCQUF3QjtJQUNsQyxNQUFNLEVBQUUscUJBQXFCO0lBQzdCLFVBQVUsRUFBRSxxQkFBcUI7SUFDakMsSUFBSSxFQUFFLHVCQUF1QjtJQUM3QixTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLEtBQUssRUFBRSx1QkFBdUI7SUFDOUIsU0FBUyxFQUFFLHNCQUFzQjtJQUNqQyxVQUFVLEVBQUUsd0JBQXdCO0lBQ3BDLElBQUksRUFBRSx3QkFBd0I7SUFDOUIsUUFBUSxFQUFFLHdCQUF3QjtJQUNsQyxTQUFTLEVBQUUscUJBQXFCO0lBQ2hDLE1BQU0sRUFBRSxzQkFBc0I7SUFDOUIsVUFBVSxFQUFFLHNCQUFzQjtJQUNsQyxXQUFXLEVBQUUsc0JBQXNCO0lBQ25DLElBQUksRUFBRSxzQkFBc0I7SUFDNUIsUUFBUSxFQUFFLHNCQUFzQjtJQUNoQyxTQUFTLEVBQUUsdUJBQXVCO0lBQ2xDLElBQUksRUFBRSx1QkFBdUI7SUFDN0IsUUFBUSxFQUFFLG9CQUFvQjtJQUM5QixTQUFTLEVBQUUscUJBQXFCO0lBQ2hDLE1BQU0sRUFBRSx3QkFBd0I7SUFDaEMsVUFBVSxFQUFFLHVCQUF1QjtJQUNuQyxXQUFXLEVBQUUsd0JBQXdCO0lBQ3JDLEdBQUcsRUFBRSxvQkFBb0I7SUFDekIsT0FBTyxFQUFFLHNCQUFzQjtJQUMvQixRQUFRLEVBQUUsc0JBQXNCO0lBQ2hDLEtBQUssRUFBRSxxQkFBcUI7SUFDNUIsU0FBUyxFQUFFLHdCQUF3QjtJQUNuQyxVQUFVLEVBQUUsd0JBQXdCO0lBQ3BDLEtBQUssRUFBRSxrQkFBa0I7SUFDekIsU0FBUyxFQUFFLHdCQUF3QjtJQUNuQyxVQUFVLEVBQUUsd0JBQXdCO0lBQ3BDLElBQUksRUFBRSxxQkFBcUI7SUFDM0IsUUFBUSxFQUFFLHFCQUFxQjtJQUMvQixTQUFTLEVBQUUscUJBQXFCO0lBQ2hDLEtBQUssRUFBRSx3QkFBd0I7SUFDL0IsT0FBTyxFQUFFLHNCQUFzQjtJQUMvQixTQUFTLEVBQUUsdUJBQXVCO0lBQ2xDLGFBQWEsRUFBRSx1QkFBdUI7SUFDdEMsY0FBYyxFQUFFLHFCQUFxQjtJQUNyQyxPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLFlBQVksRUFBRSx1QkFBdUI7SUFDckMsS0FBSyxFQUFFLHNCQUFzQjtJQUM3QixTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLFVBQVUsRUFBRSx3QkFBd0I7SUFDcEMsS0FBSyxFQUFFLHFCQUFxQjtJQUU1QixtQ0FBbUM7SUFDbkMsVUFBVSxFQUFFLHVCQUF1QjtJQUNuQyxhQUFhLEVBQUUseUJBQXlCO0lBQ3hDLGFBQWEsRUFBRSwwQkFBMEI7SUFDekMsYUFBYSxFQUFFLHlCQUF5QjtJQUN4QyxhQUFhLEVBQUUseUJBQXlCO0lBQ3hDLGFBQWEsRUFBRSx5QkFBeUI7SUFDeEMsYUFBYSxFQUFFLHlCQUF5QjtJQUV4QyxPQUFPLEVBQUUsdUJBQXVCO0lBQ2hDLFVBQVUsRUFBRSx5QkFBeUI7SUFDckMsVUFBVSxFQUFFLDBCQUEwQjtJQUN0QyxVQUFVLEVBQUUseUJBQXlCO0lBQ3JDLFVBQVUsRUFBRSx5QkFBeUI7SUFDckMsVUFBVSxFQUFFLHlCQUF5QjtJQUVyQyxNQUFNLEVBQUUsc0JBQXNCO0lBQzlCLFNBQVMsRUFBRSx3QkFBd0I7SUFDbkMsU0FBUyxFQUFFLHlCQUF5QjtJQUNwQyxTQUFTLEVBQUUsd0JBQXdCO0lBQ25DLFNBQVMsRUFBRSx3QkFBd0I7SUFDbkMsU0FBUyxFQUFFLHdCQUF3QjtJQUVuQyxRQUFRLEVBQUUsd0JBQXdCO0lBQ2xDLFdBQVcsRUFBRSwwQkFBMEI7SUFDdkMsV0FBVyxFQUFFLDJCQUEyQjtJQUN4QyxXQUFXLEVBQUUsMEJBQTBCO0lBQ3ZDLFdBQVcsRUFBRSwwQkFBMEI7SUFDdkMsV0FBVyxFQUFFLDBCQUEwQjtJQUV2QyxRQUFRLEVBQUUsdUJBQXVCO0lBQ2pDLFdBQVcsRUFBRSx5QkFBeUI7SUFDdEMsV0FBVyxFQUFFLDBCQUEwQjtJQUN2QyxXQUFXLEVBQUUseUJBQXlCO0lBQ3RDLFdBQVcsRUFBRSx5QkFBeUI7SUFDdEMsV0FBVyxFQUFFLHlCQUF5QjtDQUN2QyxDQUFDIn0=